import { map, Observable, OperatorFunction } from 'rxjs';

export function shuffle<T>(): OperatorFunction<T[], T[]> {
  return (source: Observable<T[]>): Observable<T[]> => source.pipe(map(shuffleFn));
}

function shuffleFn<T>(array: T[]) {
  let currentIndex = array.length;

  while (currentIndex !== 0) {
    const randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
  }
  return array;
}
